import React, { useEffect, useRef, useState } from "react";
import { Link } from 'react-router-dom';
import $ from "jquery";
import axiosInstance from "../../../services/api";
import "datatables.net";
import "../../../../node_modules/datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt";
import "../../../../node_modules/datatables.net-responsive-dt/css/responsive.dataTables.min.css";
import Loader from '../../Commons/Loader';
import Swal from "sweetalert2";
import { useHistory } from 'react-router-dom';
import { useMenu } from '../../../context/MenuContext';
function AllRole() {
    const history = useHistory();
    const tableRef = useRef(null);
    const [roleListingData, setRoleListingData] = useState([]);
    const [loading, setLoading] = useState(true);
    const menuArr = useMenu();
    // Fetch roles data from the API
    const fetchData = async () => {
        try {
            const response = await axiosInstance.get('user/role/get-all-roles');
            setRoleListingData(response.data.data || []);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    // Handle delete logic
    const handleDelete = async (roleId) => {
        const { isConfirmed } = await Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to delete this role?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!"
        });

        if (!isConfirmed) return;

        try {
            let forceDeleteFlag = false; // Local state for forceDelete
    
            const attemptDelete = async () => {
                try {
                    const payload = {
                        id: roleId,
                        forceDelete: forceDeleteFlag, // Use local variable
                    };
    
                    const response = await axiosInstance.post(`user/role/delete`, payload);
                    console.log("API Response:", response.data); // Debugging API response
    
                    if (response.data.status.code === 200) {
                        const { needCofirmation } = response.data.data; // Corrected property access
                        const { message } = response.data.status;
    
                        // If role is assigned, show warning message
                        if (needCofirmation) {
                            setLoading(false); // Hide loader before showing confirmation modal
    
                            const { isConfirmed: secondConfirm } = await Swal.fire({
                                title: "Cannot Delete!",
                                text: message,
                                icon: "error",
                                showCancelButton: true,
                                confirmButtonText: "Yes, delete it!",
                                cancelButtonText: "No, cancel!",
                            });
    
                            if (secondConfirm) {
                                setLoading(true); // Turn loader back on before retry
                                forceDeleteFlag = true; // Set forceDelete to true
                                return attemptDelete(); // Retry delete with forceDelete
                            } else {
                                return; // If user cancels, stop execution
                            }
                        }
    
                        // If role is successfully deleted
                        await Swal.fire({
                            title: "Deleted!",
                            text: message,
                            icon: "success",
                            confirmButtonText: "OK",
                        });
                        setRoleListingData(prevData => prevData.filter(role => role.id !== roleId));

    
                    } else {
                        throw new Error(response.data.status.message || "Failed to delete role");
                    }
                } catch (error) {
                    console.error("Error deleting role:", error);
                    Swal.fire({
                        title: "Error!",
                        text: error.response?.data?.status?.message || "Error deleting role. Please try again.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                } finally {
                    setLoading(false); // Ensure the loader is turned off after every attempt
                }
            };
    
            await attemptDelete(); // Initial delete attempt
        } catch (error) {
            console.error("Error deleting role:", error);
            Swal.fire({
                title: "Error!",
                text: "Error deleting role. Please try again.",
                icon: "error",
                confirmButtonText: "OK",
            });
        } finally {
            setLoading(false); // Ensure the loader is turned off in all cases
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Initialize DataTable and handle updates on roleListingData change
    useEffect(() => {
        if (roleListingData.length > 0) {
            const tableElement = $(tableRef.current);
            
            // Ensure previous DataTable instance is destroyed before reinitializing
            if ($.fn.dataTable.isDataTable(tableElement)) {
                tableElement.DataTable().clear().destroy(); // Destroy and clear the old DataTable instance
            }

            // Initialize new DataTable
            const table = tableElement.DataTable({
                paging: true,
                searching: true,
                lengthChange: true,
                ordering: true,
                responsive: {
                   
                },
                columnDefs: [
                    { targets: 0, responsivePriority: 0 }, // Name - Always visible
                    { targets: 2, responsivePriority: 2 }, // Operations - Always visible
                ],
                columns: [
                    { title: "Name" },
                    { title: "Description" },
                    { title: "Operations" }
                ]
            });

            const formattedData = roleListingData.map(item => [
                item.name,
                item.description,
                // `<div>
                //     <a class="edit" onclick="navigateToEdit(event, ${item.id})">
                //         <i class="nav-icon fas fa-pencil-alt"></i>
                //     </a>
                //     <button
                //         class="delete ml-2 btn btn-danger"
                //         data-id="${item.id}"
                //     >
                //         <i class="nav-icon fas fa-trash-alt"></i>
                //     </button>
                // </div>`
                `<div>
                    ${showAddRole ? `<a class="edit" onclick="navigateToEdit(event, ${item.id})">
                        <i class="nav-icon fas fa-pencil-alt"></i>
                    </a>` : ""}
                    <button class="delete ml-2 btn btn-danger" data-id="${item.id}">
                        <i class="nav-icon fas fa-trash-alt"></i>
                    </button>
                </div>`
            ]);
            window.navigateToEdit = (event, id) => {
                event.preventDefault(); // Prevent page reload
                history.push(`/edit-role/${id}`);  // Change URL without reload
            };
            // Clear the table, add the new data, and redraw
            table.clear();
            table.rows.add(formattedData);
            table.draw();

            // Event delegation for delete button click
            tableElement.on("click", ".delete", function () {
                const roleId = $(this).data("id");
                handleDelete(roleId);
            });

            // Clean up when the component unmounts
            return () => {
                tableElement.DataTable().destroy();
                tableElement.off("click", ".delete");
            };
        }
    }, [roleListingData]);
    useEffect(() => {
        const handleResize = () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().columns.adjust().responsive.recalc();
            }
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const menuArrNw = menuArr.menuArr;
    const checkAddRole = () => {
        return menuArrNw.some(menu =>
            menu.subMenus.some(subMenu => subMenu.id === "add-role")
        );
    };
    const showAddRole = checkAddRole();


    return (
        <>
            {loading && <Loader />}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6 title-mob">
                            <h1 className="m-0">All Roles</h1>
                            {showAddRole && <Link className="btn btn-primary submit-btn" to="/add-role">Add Role</Link>}
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">All Role</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid border-top pt-4">
                    <table ref={tableRef} className="display styled-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Description</th>
                                <th>Operations</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Table body is populated through DataTable initialization */}
                        </tbody>
                    </table>
                </div>
            </section>
        </>
    );
}

export default AllRole;
